exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-90820b28] .el-card__body{height:100%}.title[data-v-90820b28]{color:var(--textColor);position:relative}.title[data-v-90820b28]:before{position:absolute;content:\"\";width:2px;height:70%;left:-8px;top:4px;background-color:var(--systemColor)}.detail-height[data-v-90820b28]{height:calc(100% - 102px)}.custom-title[data-v-90820b28]{color:var(--textColor)}", ""]);

// exports
